import { render, staticRenderFns } from "./CamerasRecebidas.vue?vue&type=template&id=2a1c7443&scoped=true"
import script from "./CamerasRecebidas.vue?vue&type=script&lang=js"
export * from "./CamerasRecebidas.vue?vue&type=script&lang=js"
import style0 from "./CamerasRecebidas.vue?vue&type=style&index=0&id=2a1c7443&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c7443",
  null
  
)

export default component.exports